"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarNameTitle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var _1 = require(".");
var AvatarNameTitle = function (_a) {
    var image = _a.image, name = _a.name, title = _a.title;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: image, className: "square-xxl rounded-circle object-fit-cover mb-4", alt: name }), (0, jsx_runtime_1.jsx)(_1.NameTitle, { name: name, title: title })] }));
};
exports.AvatarNameTitle = AvatarNameTitle;
